import React, { useState } from "react";

import { cx } from "~/tools/class-variance";

import type { BorgContextPin } from "../models/borg-types";

import { pinKey } from "./_use-context-bar-state";

const COLLAPSE_THRESHOLD = 4;
const VISIBLE_WHEN_COLLAPSED = 3;

interface CollapsiblePinListProps {
	pins: ReadonlyArray<BorgContextPin>;
	renderPin: (pin: BorgContextPin) => React.ReactNode;
	suffix?: React.ReactNode;
	className?: string;
}

export const CollapsiblePinList: React.FC<CollapsiblePinListProps> = ({ pins, renderPin, suffix, className }) => {
	const [expanded, setExpanded] = useState(false);

	const needsCollapse = pins.length >= COLLAPSE_THRESHOLD;
	const visiblePins = needsCollapse && !expanded ? pins.slice(0, VISIBLE_WHEN_COLLAPSED) : pins;
	const hiddenCount = pins.length - VISIBLE_WHEN_COLLAPSED;

	return (
		<div className={cx("flex flex-wrap gap-1", className)}>
			{visiblePins.map((pin) => (
				<React.Fragment key={pinKey(pin)}>{renderPin(pin)}</React.Fragment>
			))}
			{needsCollapse && (
				<button
					className="cursor-pointer rounded-full border border-grey-300 bg-grey-100 px-2 py-0.5 text-grey-500 text-xs transition-colors hover:bg-grey-200"
					onClick={() => setExpanded((state) => !state)}
					type="button"
				>
					{expanded ? "show less" : `and ${hiddenCount} more`}
				</button>
			)}
			{suffix}
		</div>
	);
};
